export default function progressSlider() {

    const progressSlider = document.querySelector('.js-progressSlider');

    if (!progressSlider) {
        return false;
    }

    function initProgressSlider() {

        if (progressSlider.childElementCount == 1) {
            return false;
        }

        if (progressSlider.childElementCount <= 3 && window.innerWidth > 1200) {
            return false;
        }

        if (progressSlider.childElementCount <= 2 && window.innerWidth <= 1200 && window.innerWidth > 820) {
            return false;
        }

        $('.js-progressSlider').not('.slick-initialized').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            dotsClass: 'progress_dots',
            prevArrow: '<button type="button" class="progress_arrow-prev"></button>',
            nextArrow: '<button type="button" class="progress_arrow-next"></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 820,
                    settings: {
                        slidesToShow: 1,
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(initProgressSlider);

}